export default __webpack_public_path__ + "static/media/truthtake3.744af481.mp3";